define('app-Agents/modules/passwordStrength/settings',[],function () {
    return {
        container: ".strengthIndicator",
        passwordField: "#Password",
        confirmPasswordField: "#ConfirmPassword",
        minCharacterLi: ".minCharactersTest",
        lowercaseUppercaseLi: ".lowercaseUppercaseLetterTest",
        numberLi: ".numberTest",
        specialCharacterLi: ".specialCharacterTest",
        matchingLi: ".matchingPasswordsTest",
        password: {
            minCharacters: 8,
            mustContainLowercaseUppercase: true,
            mustContainNumber: true,
            mustContainSpecialCharacter: true
        }
    };
});
